import { Validators } from '@angular/forms';

export const sugarContentValidators = [
  Validators.min(0),
  Validators.max(100),
  Validators.required,
];
